<template>
	<transition name="fade" v-if="config.show">
		<div class="modal-box">
			<div class="modal modal-sm alert">
				<div class="modal-body text-center">
					<slot>
						<h2 class="text-center" v-html="config.msg"></h2><br>
					</slot>
					<button v-if="config.btn.name" :class="config.btn.classNames" type="button" @click="config.btn.fn?config.btn.fn():$emit('close')">&nbsp;&nbsp;{{config.btn.name}}&nbsp;&nbsp;</button>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
export default {
	name: "ModalAlert",

	default: function() {
		return {
			name: this.name,
			msg: "",
			show: false,
			btn: {
				name: "확인",
				fn: null,
				classNames: "btn btn-darkgray round"
			}
		}
	},

	props: {
		config: Object
	}
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
	transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
	opacity: 0;
}
</style>